import React from "react";
import { Button } from "reactstrap";

const NotFoundPage = ({ handleGoHome }) => {
  return (
    <div className="sv-404-container mt--6">
      <h1 className="error-heading">404</h1>
      <h2 className="error-subHeading">Page Not Found</h2>
      <p className="error-msg">
        The page you are looking for does not exist or may have been moved.
        Please check the URL or return to the Jointer Verification Portal
        homepage.
      </p>
      <Button color="danger" onClick={handleGoHome} className="btn-style">
        Go to Home
      </Button>
    </div>
  );
};

export default NotFoundPage;
